import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { QueryClientProvider } from 'react-query';
import { queryClient } from './api/react-query';
// import * as Sentry from '@sentry/react';

// Only initialize Sentry in production
// if (import.meta.env.PROD) {
//   Sentry.init({
//     dsn: 'https://867fd4b2435871180b5606d20021e1a3@sentry.wtmsrv.com/64',
//     environment: 'production',
//     integrations: [],
//     // Performance Monitoring
//     tracesSampleRate: 1.0,
//     // Session Replay
//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1.0,
//   });
// }

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
